__turbopack_context__.v({
  "skeleton": "lQN0jG_skeleton",
});
